import * as universal from "../../../../src/routes/+page.ts";
export { universal };